// extracted by mini-css-extract-plugin
export default {"form":"L8P1M","inner":"G3ji5","actions":"gypI_","action":"LbsH5"};